import React from "react";

import { Modal } from "@shared/components";
import { useTranslate } from "@refinedev/core";

import { SubscriptionForm } from "../SubscriptionForm";
import { EditSubscriptionModalProps } from "./types";
import { useEditSubscriptionModal } from "./controller";

export const EditSubscriptionModal = React.memo(({ modalRef, onComplete }: EditSubscriptionModalProps) => {
  const translate = useTranslate();

  const { methods, handleSubmit, isPending } = useEditSubscriptionModal(modalRef, onComplete);

  return (
    <Modal
      ref={modalRef}
      title={translate("subscription_admin.titles.edit")}
      onConfirm={handleSubmit}
      methods={methods}
      isPending={isPending}
    >
      <SubscriptionForm />
    </Modal>
  );
});
